import ajax from "@/lib/ajax";
/**
 * 读取宣教执行信息
 * @param patientId 患者Id
 */
export async function GetExecuteEducationList(patientId: string) {
    let res = await ajax.get(`/api/services/app/PDEducation/GetExecuteEducationList?patientId=` + patientId);
    return res.data.result;
}

/**
 * 新增宣教完成情况
 * @param payload 
 */
export async function InsertExecuteEducation(payload: any) {
    let res = await ajax.post(`/api/services/app/PDEducation/InsertExecuteEducation`, payload);
    return res.data.result;
}

/**
 * 删除宣教任务
 * @param id
 */
export async function DeleteEducation(id: number) {
    let res = await ajax.delete(`/api/services/app/PDEducation/DeleteEducation?id=` + id);
    return res.data.result;
}
    


// WEBPACK FOOTER //
// ./src/api/pdOutPatient/pdEducation/pdExecuteEducation/index.ts